
import PropTypes from 'prop-types'
import React from 'react'
import css from './index.module.css'
import Checkbox from '../Checkbox'
import classnames from 'classnames'

const CheckboxTile = props => {
  const { logo, title, description, isChecked, isDisabled, name, value, isRadio, onChange } = props
  const classes = classnames({ [css.main]: true })

  return (
    <label className={classes}> {/* HACK: the entire tile is a <label> so it's clickable */}
      <img className={css.logo} src={logo} alt={title} />

      <h4 className={css.title}>{title}</h4>

      <div className={css.description}>
        {description}
      </div>

      <div className={css.checkbox}>
        <Checkbox
          initialChecked={isChecked}
          isDisabled={isDisabled}
          name={name}
          value={value}
          onChange={onChange}
          isRadio={isRadio} />
      </div>
    </label>
  )
}

CheckboxTile.propTypes = {
  logo: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isRadio: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
}

CheckboxTile.displayName = 'CheckboxTile'

export default CheckboxTile



// WEBPACK FOOTER //
// ./ui/CheckboxTile/index.js